import {
  addDoc,
  collection,
  doc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore';
import { db } from '../firebase';

export interface SchoolSummary {
  id: string;
  name?: string;
  academy?: string;
  region?: string;
  commune?: string;
  address?: string;
  status?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

const COLLECTION = 'schools';

export async function listSchoolsSummary(): Promise<SchoolSummary[]> {
  const snap = await getDocs(
    query(collection(db, COLLECTION), orderBy('name', 'asc'))
  );

  return snap.docs.map((d) => {
    const data = d.data() as any;
    return {
      id: d.id,
      name: data.name,
      academy: data.academy,
      region: data.region,
      commune: data.commune,
      address: data.address,
      status: data.status,
      createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : undefined,
      updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : undefined,
    };
  });
}

export async function toggleSchoolStatus(
  id: string,
  current?: string
): Promise<void> {
  const ref = doc(db, COLLECTION, id);
  const next = current === 'active' ? 'inactive' : 'active';
  await updateDoc(ref, { status: next });
}

export async function updateSchool(
  id: string,
  payload: {
    name: string;
    academy: string;
    region: string;
    commune: string;
    address: string;
    status: string;
  }
): Promise<void> {
  const ref = doc(db, COLLECTION, id);
  await updateDoc(ref, {
    name: payload.name.trim(),
    academy: payload.academy.trim() || null,
    region: payload.region.trim() || null,
    commune: payload.commune.trim() || null,
    address: payload.address.trim() || null,
    status: payload.status,
    updatedAt: new Date(),
  });
}

export async function createSchool(payload: {
  name: string;
  academy: string;
  region: string;
  commune: string;
  address: string;
  status: string;
}): Promise<string> {
  const ref = await addDoc(collection(db, COLLECTION), {
    name: payload.name.trim(),
    academy: payload.academy.trim() || null,
    region: payload.region.trim() || null,
    commune: payload.commune.trim() || null,
    address: payload.address.trim() || null,
    status: payload.status,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return ref.id;
}

